import QueryEmployeeFavourites from "graphql/queries/QueryEmployeeFavourites";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import QueryAppMessages from 'graphql/queries/QueryAppMessages'

const FetchAppMessages = {
	
	fetchAll: ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'app_messages', QueryAppMessages, {
			resultPath: [ 'app_messages' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}

export default FetchAppMessages
